import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PlayerButton } from './PlayerButton';
export const SkipForwardButton = React.memo(function SkipForwardButton({ mediaElementId, onClick }) {
    return (_jsx(PlayerButton, { className: "hekate-player-skip-forward-btn", tooltip: "Forward 5 seconds", "aria-controls": mediaElementId, onClick: onClick }));
});
